import React from "react";
import classes from './Footer.module.scss'

const Footer = () => {
  return (
    <footer className={classes.footer}>
      Alexander&copy;
    </footer>
  );
}

export default Footer;